import React from "react";
import {withRouter} from 'react-router-dom';

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";

// core components
import CustomInput from "components/CustomInput/CustomInput.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

import ToolTipIcon from "views/Components/ToolTipIcon"

import customSelectStyle from "assets/jss/material-dashboard-pro-react/customSelectStyle.jsx";
import regularFormsStyle from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
import { verifyLength, verifyZip, verifyPhone, verifyNumberExactLengthExcludeNonNumeric, setToolTipArray } from "../../../assets/helpers/formHelper";
import { getApiHeaders } from "../../../assets/helpers/apiHelper";

import axios from 'axios';
import { API_ROOT, DEFAULT_US_STATE } from 'api-config';

const usStateList = require('../../../assets/selectLists/usStates.json');

const style = {
  infoText: {
    fontWeight: "300",
    margin: "10px 0 30px",
    textAlign: "center"
  },
  ...customSelectStyle,
  ...regularFormsStyle
};

class Address extends React.Component {
  constructor(props) {
    super(props);
    var signupType;
    switch (this.props.location.pathname) {
      case '/signupProvider':
        signupType = 'provider'
        break
      case '/signupEmployer':
        signupType = 'employer'
        break
      default:
        signupType = 'patient'
        break
    }

    this.state = {
      address1: "",
      address2: "",
      addressCity: "",
      addressState: DEFAULT_US_STATE,
      addressZip: "",
      addressZipState: "",
      phone: "",
      phoneState: "",
      cellphone: "",
      cellphoneState: "",
      taxId: "",
      taxIdState: "",
      taxClassification: "",
      taxClassificationState: "",
      taxClassificationOptions: [],
      tooltips: {},
      signupType: signupType
    };
  }
  sendState() {
    return this.state;
  }
  change(event, stateName, type, stateNameEqualTo, emptyOkay) {
    if (emptyOkay && !event.target.value) {
      this.setState({ [stateName + "State"]: "" });
    } else {
      switch (type) {
        case "phone":
          if (verifyPhone(event.target.value)) {
            this.setState({ [stateName + "State"]: "success" });
          } else {
            this.setState({ [stateName + "State"]: "error" });
          }
          break;
        case "length":
          if (verifyLength(event.target.value, stateNameEqualTo)) {
            this.setState({ [stateName + "State"]: "success" });
          } else {
            this.setState({ [stateName + "State"]: "error" });
          }
          break;
        case "zip":
          if (verifyZip(event.target.value, stateNameEqualTo)) {
            this.setState({ [stateName + "State"]: "success" });
          } else {
            this.setState({ [stateName + "State"]: "error" });
          }
          break;
        default:
          break;
        case "numberExactLengthExcludeNonNumeric":
          if (verifyNumberExactLengthExcludeNonNumeric(event.target.value, stateNameEqualTo)) {
            this.setState({ [stateName + "State"]: "success" });
          } else {
            this.setState({ [stateName + "State"]: "error" });
          }
          break;
      }
    }

    this.setState({ [stateName]: event.target.value });
  };

  isValidated() {
    //here, we want to allow empty fields for zip and phone, so if those fields have not been touched, the user can proceed
    //if they are not empty, we validate for a correct format
    if (
      (this.state.addressZipState === "success" || this.state.addressZipState === "") &&
      (this.state.phoneState === "success" || this.state.phoneState === "") &&
      (this.state.cellphoneState === "success" || this.state.cellphoneState === "") &&
      (this.state.taxIdState === "success" || this.state.taxIdState === "") &&
      (this.state.taxClassificationState === "success" || this.state.taxClassificationState === "")
    ) {
      return true;
    }
    return false;
  }

  componentDidMount(){
    axios.get(`${API_ROOT}/organizationTypes/`, { headers: getApiHeaders() })
      .then(res => this.setOrganizationTaxClassifications({ responseMessage: res.data }));
    var formType = ''
    switch (this.state.signupType) {
      case "provider":
        formType = 'registrationAddressProvider'
        break
      case "employer":
        formType = 'registrationAddressEmployer'
        break
      default:
        formType = 'registrationAddress'
        break
    }
    axios.get(`${API_ROOT}/toolTip/?formType=` + formType, { headers: getApiHeaders() })
      .then(res => this.setTooltips({ responseMessage: res.data }));
  }

  setOrganizationTaxClassifications(taxClassificationData) {
    this.setState({
      taxClassificationOptions: taxClassificationData.responseMessage
    })
  }

  setTooltips(tooltipData) {
    this.setState({
      tooltips: setToolTipArray(tooltipData)
    })
  }

  render() {
    const { classes } = this.props;
    return (
      <GridContainer justifyContent="center">
        <GridItem xs={12} sm={12}>
          <h4 className={classes.infoText}>Please provide your address and phone number.</h4>
        </GridItem>
        <GridItem xs={12} sm={5}>
          <CustomInput
            labelText="address"
            id="address1"
            formControlProps={{
              fullWidth: true
            }}
            inputProps={{
              onChange: event => this.change(event, "address1"),
              endAdornment: (
                <ToolTipIcon
                  tooltipText={this.state.tooltips['address1']}
                />
              )

            }}
          />
        </GridItem>
        <GridItem xs={12} sm={5}>
          <CustomInput
            labelText="address"
            id="address2"
            formControlProps={{
              fullWidth: true
            }}
            inputProps={{
              onChange: event => this.change(event, "address2"),
              endAdornment: (
                <ToolTipIcon
                  tooltipText={this.state.tooltips['address2']}
                />
              )

            }}
          />
        </GridItem>
        <GridItem xs={12} sm={5}>
          <CustomInput
            labelText="city"
            id="addressCity"
            formControlProps={{
              fullWidth: true
            }}
            inputProps={{
              onChange: event => this.change(event, "addressCity"),
              endAdornment: (
                <ToolTipIcon
                  tooltipText={this.state.tooltips['addressCity']}
                />
              )

            }}
          />
        </GridItem>
        <GridItem xs={12} sm={3}>
          <FormControl
            fullWidth
            className={classes.selectFormControl}
          >
            <InputLabel
              htmlFor="simple-select"
              className={classes.selectLabel}
            >
              state
            </InputLabel>
            <Select
              MenuProps={{
                className: classes.selectMenu
              }}
              classes={{
                select: classes.select
              }}
              value={this.state.addressState}
              onChange={this.handleChangeSelect}

              inputProps={{
                id: "addressState",
                name: "addressState",
                onChange: event => this.change(event, "addressState")
              }}

            >
              <MenuItem
                disabled
                classes={{
                  root: classes.selectMenuItem
                }}
              >
                Choose state
              </MenuItem>
              {usStateList.map((usState) =>
                <MenuItem classes={{
                  root: classes.selectMenuItem,
                  selected: classes.selectMenuItemSelected
                }} key={usState.abbreviation} value={usState.abbreviation} >{usState.name}</MenuItem>
              )}

            </Select>
          </FormControl>
        </GridItem>

        <GridItem xs={12} sm={2}>
          <CustomInput
            success={this.state.addressZipState === "success"}
            error={this.state.addressZipState === "error"}
            labelText="ZIP"
            id="addressZip"
            formControlProps={{
              fullWidth: true
            }}
            inputProps={{
              onChange: event => this.change(event, "addressZip", "zip", '', true),
              endAdornment: (
                <ToolTipIcon
                  tooltipText={this.state.tooltips['addressZip']}
                />
              )

            }}
          />
        </GridItem>

        <GridItem xs={12} sm={5}>
          <CustomInput
            success={this.state.phoneState === "success"}
            error={this.state.phoneState === "error"}
            labelText="phone"
            id="phone"
            formControlProps={{
              fullWidth: true
            }}
            inputProps={{
              onChange: event => this.change(event, "phone", "phone", '', true),
              endAdornment: (
                <ToolTipIcon
                  tooltipText={this.state.tooltips['phone']}
                />
              )

            }}
          />
        </GridItem>
        <GridItem xs={12} sm={5}>
          <CustomInput
            success={this.state.cellphoneState === "success"}
            error={this.state.cellphoneState === "error"}
            labelText="cell phone"
            id="cellphone"
            formControlProps={{
              fullWidth: true
            }}
            inputProps={{
              onChange: event => this.change(event, "cellphone", "phone", '', true),
              endAdornment: (
                <ToolTipIcon
                  tooltipText={this.state.tooltips['cellphone']}
                />
              )
            }}
          />
        </GridItem>
        <GridItem xs={12} sm={5} style={this.state.signupType === 'provider' || this.state.signupType === 'employer' ? {} : { display: 'none' }}>
          <CustomInput
            success={this.state.taxIdState === "success"}
            error={this.state.taxIdState === "error"}
            labelText={
              <span>
                Tax ID
              </span>
            }
            id="taxId"
            formControlProps={{
              fullWidth: true
            }}
            inputProps={{
              onChange: event => this.change(event, "taxId", "numberExactLengthExcludeNonNumeric", '9', true),
              endAdornment: (
                <ToolTipIcon
                  tooltipText={this.state.tooltips['taxId']}
                />
              )
            }}
          />
        </GridItem>
        <GridItem xs={12} sm={5} style={this.state.signupType === 'provider' || this.state.signupType === 'employer' ? {} : { display: 'none' }}>
          <FormControl
            fullWidth
            className={classes.selectFormControl}
          >
            <InputLabel
              htmlFor="simple-select"
              className={classes.selectLabel}
            >
              tax classification
            </InputLabel>
            <Select
              MenuProps={{
                className: classes.selectMenu
              }}
              classes={{
                select: classes.select
              }}
              value={this.state.taxClassification}
              onChange={this.handleChangeSelect}

              inputProps={{
                id: "taxClassification",
                name: "taxClassification",
                onChange: event => this.change(event, "taxClassification")
              }}

            >
              <MenuItem
                disabled
                classes={{
                  root: classes.selectMenuItem
                }}
              >
                choose classification
              </MenuItem>
              {this.state.taxClassificationOptions.map((taxClassification) =>
                <MenuItem classes={{
                  root: classes.selectMenuItem,
                  selected: classes.selectMenuItemSelected
                }} key={taxClassification[0]} value={taxClassification[0]} >{taxClassification[1]}</MenuItem>
              )}

            </Select>
          </FormControl>
        </GridItem>
        <GridItem xs={12} sm={5} style={this.state.signupType === 'provider' ? {} : { display: 'none' }}>
        </GridItem>


      </GridContainer>
    );
  }
}

export default withRouter(withStyles(style)(Address));
